import {atom} from 'jotai';
export const patternsChangedAtom = atom({
	changed: false,
	inactivePatterns: false
});